var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Icon } from "../../icon";
import { useTheme } from "styled-components";
import { StyledButton } from "./Button.styles";
import { buttonHeights, buttonStyles } from "../utils";
export const Button = (_a) => {
    var { onClick, buttonType = "button", className, symbol, children, rounded, height = { xsmall: buttonHeights.medium }, stretched = { xsmall: false }, stylingType = "secondary", iconAlignment = "left", onMouseDown, previewId, dataEditType } = _a, props = __rest(_a, ["onClick", "buttonType", "className", "symbol", "children", "rounded", "height", "stretched", "stylingType", "iconAlignment", "onMouseDown", "previewId", "dataEditType"]);
    const theme = useTheme();
    const [focused, setFocused] = useState(false);
    const [active, setActive] = useState(true);
    const rightAligned = iconAlignment === "right";
    return (
    /* eslint-disable react/button-has-type */
    _jsxs(StyledButton, Object.assign({ "data-preview-id": previewId, "data-edit-type": dataEditType, className: className, onClick: onClick, type: buttonType, onMouseDown: (e) => {
            if (typeof onMouseDown === "function")
                onMouseDown(e);
            setFocused(false);
        }, onKeyPress: () => {
            setFocused(false);
            setActive(false);
        }, onKeyUp: () => {
            setFocused(true);
            setActive(true);
        }, onBlur: () => setFocused(false), focused: focused, active: active, stylingType: buttonStyles(theme)[stylingType], hasChildren: !!children, iconAlignment: iconAlignment, itemHeight: height, stretched: stretched, rounded: rounded, symbol: symbol }, props, { children: [symbol && !rightAligned && _jsx(Icon, { symbol: symbol }), children, symbol && rightAligned && _jsx(Icon, { symbol: symbol })] })));
};
